"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipoFalloItemSchema = exports.CopiarIdentificadoresSchema = exports.CampoIdentificadorSchema = exports.DescartarEntrantesSchema = exports.ElegirAccionSchema = exports.DevolverConflictoSchema = exports.DecidirConflictoSchema = exports.DevolverDecisionSchema = exports.AceptarMejorCandidatoSchema = exports.DecidirUnidadSchema = exports.DecidirInvestigadorSchema = exports.DetalleEntranteResponseSchema = exports.ListarErroresResponseSchema = exports.ErrorCorridaSchema = exports.ContadoresPublicacionesResponseSchema = exports.ListarEntrantesResponseSchema = exports.FilaEntranteSchema = exports.ResumenEntranteSchema = exports.PublicacionCandidataVistaSchema = exports.ConflictoVistaSchema = exports.DecisionVistaSchema = exports.AceptadoVistaSchema = exports.CandidatoVistaSchema = exports.EntranteResumenSchema = exports.RevistaVistaSchema = exports.ListarErroresQuerySchema = exports.ContadoresQuerySchema = exports.ListarEntrantesQuerySchema = exports.CAMPOS_EN_CONFLICTO = exports.IdentificadoresAutorSchema = exports.CandidatoUnidadSchema = exports.CandidatoInvestigadorSchema = exports.CASOS_POR_TAB = exports.CASOS_DECISION = exports.CasoPublicacionSchema = exports.CASOS_PUBLICACIONES = exports.TabPublicacionesSchema = exports.TABS_PUBLICACIONES = exports.TIPOS_ERROR_PUBLICACION = exports.FUENTE_POR_CODIGO_IMPORTACION = exports.CODIGOS_AUTOMATIZACION_PUBLICACIONES = exports.CODIGO_ERROR_VALOR_DISTINTO = exports.MetodoCoincidenciaAutorSchema = exports.OrigenDecisionAutorSchema = exports.EstadoDecisionPublicacionSchema = exports.TipoDecisionAutorSchema = exports.AccionPublicacionEntranteSchema = exports.EstadoPublicacionEntranteSchema = exports.FuenteDatosPublicacionSchema = exports.FUENTES_DATOS_PUBLICACION = void 0;
exports.CopiarIdentificadoresResponseSchema = exports.ColumnaIdentificadorSchema = exports.ResultadoLoteResponseSchema = exports.ResultadoItemSchema = void 0;
exports.esOrigenInferido = esOrigenInferido;
exports.casosDeTab = casosDeTab;
exports.validarValorAceptado = validarValorAceptado;
const zod_1 = require("zod");
// ───────────── Publicaciones entrantes (R67 · purgatorio de publicaciones) ─────────────
//
// Contract of the admin review screen `/admin/publicaciones` over the three tables the
// bibliometric importer (Python, `/opt/automatizaciones`, NOT in this repo) writes:
//   publicacion_entrante   — one row per (fuente, uid) detected in a source
//   decision_autor         — who each author is (`investigador`) and under which unit (`unidad`)
//   conflicto_publicacion  — a field where the source contradicts the stored publication
//
// The admin only RESOLVES what the importer could not decide; the automation
// `aplicar_decisiones_publicaciones` is what writes `publicacion`. The DB CHECKs are the spec
// of every write (see prisma/ddl/r67_publicaciones_entrantes.sql):
//   · decision/conflict estado and value move TOGETHER (`por_revisar` ⇔ value IS NULL)
//   · every decision carries `origen` (the webapp always writes `admin`)
//   · `accion` only on an entrante that has `publicaciones_candidatas`
// "External author" is `ids_aceptados = []`, never NULL (NULL = undecided).
// ─── Enums mirrored from prisma/schema.prisma ───
exports.FUENTES_DATOS_PUBLICACION = ['WoS', 'Scopus', 'SciELO', 'OpenAlex'];
exports.FuenteDatosPublicacionSchema = zod_1.z.enum(exports.FUENTES_DATOS_PUBLICACION);
exports.EstadoPublicacionEntranteSchema = zod_1.z.enum(['pendiente', 'importada', 'descartada']);
exports.AccionPublicacionEntranteSchema = zod_1.z.enum(['crear_nueva', 'actualizar_existente']);
exports.TipoDecisionAutorSchema = zod_1.z.enum(['investigador', 'unidad']);
exports.EstadoDecisionPublicacionSchema = zod_1.z.enum(['por_revisar', 'por_aplicar', 'aplicado']);
exports.OrigenDecisionAutorSchema = zod_1.z.enum([
    'registro_fuente',
    'adscripcion_por_fecha',
    'publicacion_mas_cercana',
    'adscripcion_mas_reciente',
    'admin',
]);
exports.MetodoCoincidenciaAutorSchema = zod_1.z.enum(['orcid', 'uid_fuente', 'alias']);
/**
 * The three unit origins that are FILL-IN by the importer (the paper only said
 * "Universidad de Atacama"). A declared unit and an inferred one look identical in the
 * attribution table; this is what keeps the fill-in auditable.
 */
const ORIGENES_INFERIDOS = new Set([
    'adscripcion_por_fecha',
    'publicacion_mas_cercana',
    'adscripcion_mas_reciente',
]);
function esOrigenInferido(origen) {
    return origen != null && ORIGENES_INFERIDOS.has(origen);
}
/**
 * `code` of the 409 the identifier copy answers when the investigador already holds a DIFFERENT
 * value: the only identifier conflict an admin may force with `sobrescribir`. An ORCID owned by
 * another investigador is also a 409, without this code, and can never be forced.
 */
exports.CODIGO_ERROR_VALOR_DISTINTO = 'valor_distinto';
// ─── Automations and run errors ───
/**
 * `automatizacion.codigo` of the publication automations. HARD contract: the Python runner
 * requires the codigo to be exactly a directory name under its `automations/`.
 */
exports.CODIGOS_AUTOMATIZACION_PUBLICACIONES = [
    'importar_publicaciones_wos',
    'importar_publicaciones_scopus',
    'aplicar_decisiones_publicaciones',
    'regenerar_alias_investigadores',
];
/** Ingest automations and the source each one reads. The other two have no source. */
exports.FUENTE_POR_CODIGO_IMPORTACION = {
    importar_publicaciones_wos: 'WoS',
    importar_publicaciones_scopus: 'Scopus',
};
/** `item_ejecucion_automatizacion.detalle.tipo_error` written by the importer. */
exports.TIPOS_ERROR_PUBLICACION = [
    'full_record_faltante',
    'publicacion_sin_autores_institucionales',
    'autor_con_multiples_ids_aceptados',
    'accion_sin_publicacion',
    'decision_no_aplicable',
    'revista_con_otro_issn',
    'error_inesperado',
];
// ─── Review tabs and casos ───
//
// A pending item lands in exactly ONE caso. Precedence for a `por_revisar` investigador
// decision: afiliacion_incierta (the importer flagged a concrete doubt) → >1 candidates
// (autor_ambiguo) → 0 (autor_sin_candidatos) → exactly 1 (autor_candidato_unico: one
// candidate without enough confidence to accept it). A `por_revisar` unit decision is
// always `sin_unidad`. Rows of a `descartada` entrante never show up.
exports.TABS_PUBLICACIONES = ['multiples', 'mismatch', 'todas'];
exports.TabPublicacionesSchema = zod_1.z.enum(exports.TABS_PUBLICACIONES);
exports.CASOS_PUBLICACIONES = [
    'autor_ambiguo',
    'publicacion_ambigua',
    'autor_sin_candidatos',
    'autor_candidato_unico',
    'afiliacion_incierta',
    'sin_unidad',
    'conflicto',
    'error',
];
exports.CasoPublicacionSchema = zod_1.z.enum(exports.CASOS_PUBLICACIONES);
/** Casos resolved over `decision_autor`. */
exports.CASOS_DECISION = [
    'autor_ambiguo',
    'autor_sin_candidatos',
    'autor_candidato_unico',
    'afiliacion_incierta',
    'sin_unidad',
];
exports.CASOS_POR_TAB = {
    multiples: ['autor_ambiguo', 'publicacion_ambigua'],
    mismatch: [
        'autor_sin_candidatos',
        'autor_candidato_unico',
        'afiliacion_incierta',
        'sin_unidad',
        'conflicto',
        'error',
    ],
    todas: [],
};
function casosDeTab(tab) {
    return exports.CASOS_POR_TAB[tab];
}
// ─── JSON written by the importer (snake_case, as stored) ───
exports.CandidatoInvestigadorSchema = zod_1.z.object({
    id_investigador: zod_1.z.number().int(),
    metodo: exports.MetodoCoincidenciaAutorSchema,
    /** null when metodo != 'alias' (an id identifies without scoring). */
    confianza: zod_1.z.number().nullable().optional().default(null),
    /** Alias format that matched, e.g. "N1 n2 A1 A2". null when metodo != 'alias'. */
    formato: zod_1.z.string().nullable().optional().default(null),
    coincide_unidad: zod_1.z.boolean().optional().default(false),
    nombres_no_concuerdan: zod_1.z.boolean().optional().default(false),
});
exports.CandidatoUnidadSchema = zod_1.z.object({ id_unidad: zod_1.z.number().int() });
/** Ids the source declared for the author, EVEN IF they did not identify them. */
exports.IdentificadoresAutorSchema = zod_1.z.object({
    uid_fuente: zod_1.z.string().nullable().optional().default(null),
    orcids: zod_1.z.array(zod_1.z.string()).optional().default([]),
});
// ─── conflicto_publicacion.campo → type of valor_aceptado ───
//
// Mirror of the importer's `CAMPOS_EN_CONFLICTO`. `campo` is a free VARCHAR in the DB and
// the importer only validates the two compound ones; the rest it learns from MariaDB's
// DataError, which sends the conflict back to review ("decided, looked saved, came back").
// Validating here BEFORE saving is what prevents that.
const textoNoVacio = (max) => zod_1.z.string().trim().min(1).max(max);
const issn = zod_1.z.string().length(9);
const fechaIso = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine((v) => {
    const d = new Date(`${v}T00:00:00Z`);
    return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === v;
}, 'fecha inexistente');
exports.CAMPOS_EN_CONFLICTO = {
    /** [titulo, titulo_alternativo]; the principal cannot be null. */
    titulos: zod_1.z.tuple([textoNoVacio(500), zod_1.z.string().max(500).nullable()]),
    /** [issn, eissn]; at least one. The decision applies to the WHOLE journal. */
    issn_revista: zod_1.z
        .tuple([issn.nullable(), issn.nullable()])
        .refine(([a, b]) => a !== null || b !== null, 'al menos uno de los dos ISSN'),
    /** The type DESCRIPTION, not its id. */
    tipo_publicacion: textoNoVacio(255),
    doi: textoNoVacio(250),
    año_publicacion: zod_1.z.number().int().positive().max(9999),
    fecha_early_access: fechaIso,
    fecha_indexacion: fechaIso,
    /** 0 | 1, never true/false: JSON_VALUE returns 'true' and that lands as 0 in a tinyint. */
    early_access: zod_1.z.union([zod_1.z.literal(0), zod_1.z.literal(1)]),
    volume: textoNoVacio(128),
    issue: textoNoVacio(128),
    page_start: textoNoVacio(128),
    page_end: textoNoVacio(128),
    page_count: textoNoVacio(128),
    article_number: textoNoVacio(128),
    // Valid but in practice never a conflict: titles are decided together as `titulos`.
    titulo: textoNoVacio(500),
    titulo_alternativo: textoNoVacio(500),
};
function validarValorAceptado(campo, valor) {
    const schema = Object.prototype.hasOwnProperty.call(exports.CAMPOS_EN_CONFLICTO, campo)
        ? exports.CAMPOS_EN_CONFLICTO[campo]
        : undefined;
    if (!schema) {
        return { ok: false, error: `El campo «${campo}» no se puede decidir desde el panel.` };
    }
    const r = schema.safeParse(valor);
    if (!r.success) {
        const detalle = r.error.errors.map((e) => e.message).join('; ');
        return { ok: false, error: `Valor inválido para «${campo}»: ${detalle}.` };
    }
    return { ok: true, valor: r.data };
}
// ─── Read contracts ───
const pageSchema = zod_1.z.coerce.number().int().min(1).default(1);
const pageSizeSchema = zod_1.z.coerce.number().int().min(1).max(100).default(25);
const textoBusqueda = zod_1.z
    .string()
    .trim()
    .max(200)
    .optional()
    .transform((v) => (v ? v : undefined));
exports.ListarEntrantesQuerySchema = zod_1.z
    .object({
    tab: exports.TabPublicacionesSchema,
    caso: exports.CasoPublicacionSchema.optional(),
    fuente: exports.FuenteDatosPublicacionSchema.optional(),
    /** Only for tab=todas. */
    estado: exports.EstadoPublicacionEntranteSchema.optional(),
    /** Only for tab=todas: pending entrantes stuck by an error of the latest finished run. */
    trabada: zod_1.z
        .union([zod_1.z.boolean(), zod_1.z.enum(['true', 'false'])])
        .optional()
        .transform((v) => v === true || v === 'true'),
    /** Only for caso=conflicto: one `conflicto_publicacion.campo`. */
    campo: zod_1.z.string().trim().min(1).max(64).optional(),
    /** Matches the title, the source uid, the author name and the DOI (lowercased: DOIs are stored lowercase). */
    q: textoBusqueda,
    page: pageSchema,
    pageSize: pageSizeSchema,
})
    .superRefine((v, ctx) => {
    if (v.campo !== undefined && v.caso !== 'conflicto') {
        ctx.addIssue({ code: 'custom', path: ['campo'], message: 'El filtro «campo» sólo aplica a los conflictos.' });
    }
    if (v.caso === undefined)
        return;
    if (v.caso === 'error') {
        ctx.addIssue({ code: 'custom', path: ['caso'], message: 'Los errores de corrida se listan en /errores.' });
    }
    else if (!exports.CASOS_POR_TAB[v.tab].includes(v.caso)) {
        ctx.addIssue({ code: 'custom', path: ['caso'], message: `El caso «${v.caso}» no pertenece a la pestaña «${v.tab}».` });
    }
})
    .transform((v) => ({ ...v, caso: v.caso ?? exports.CASOS_POR_TAB[v.tab][0] ?? null }));
exports.ContadoresQuerySchema = zod_1.z.object({ fuente: exports.FuenteDatosPublicacionSchema.optional() });
exports.ListarErroresQuerySchema = zod_1.z.object({
    fuente: exports.FuenteDatosPublicacionSchema.optional(),
    tipoError: zod_1.z.string().trim().min(1).max(64).optional(),
    /** `ultimas` = only the latest FINISHED run of each publication automation (default). */
    alcance: zod_1.z.enum(['ultimas', 'todas']).default('ultimas'),
    page: pageSchema,
    pageSize: pageSizeSchema,
});
const UsuarioRefSchema = zod_1.z.object({ idUsuario: zod_1.z.number().int(), nombre: zod_1.z.string() });
/**
 * A stored journal (`revista_cientifica`), shown next to an ISSN conflict or error. Its ISSNs come
 * from `revista_issn` (R68), which does not tell print from electronic: sorted, possibly empty.
 */
exports.RevistaVistaSchema = zod_1.z.object({
    idRevista: zod_1.z.number().int(),
    titulo: zod_1.z.string().nullable(),
    issns: zod_1.z.array(zod_1.z.string()),
});
exports.EntranteResumenSchema = zod_1.z.object({
    idPublicacionEntrante: zod_1.z.number().int(),
    fuente: exports.FuenteDatosPublicacionSchema,
    uidFuente: zod_1.z.string(),
    titulo: zod_1.z.string().nullable(),
    anoPublicacion: zod_1.z.number().int().nullable(),
    link: zod_1.z.string().nullable(),
    estado: exports.EstadoPublicacionEntranteSchema,
    idPublicacion: zod_1.z.number().int().nullable(),
    accion: exports.AccionPublicacionEntranteSchema.nullable(),
    observaciones: zod_1.z.string().nullable(),
    idEjecucion: zod_1.z.number().int().nullable(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
/** A candidate (investigador or unidad) enriched with its display name and its "why". */
exports.CandidatoVistaSchema = zod_1.z.object({
    id: zod_1.z.number().int(),
    /** null when the id no longer exists in the DB. */
    nombre: zod_1.z.string().nullable(),
    /** Public profile slug (investigador only). */
    slug: zod_1.z.string().nullable(),
    metodo: exports.MetodoCoincidenciaAutorSchema.nullable(),
    confianza: zod_1.z.number().nullable(),
    formato: zod_1.z.string().nullable(),
    coincideUnidad: zod_1.z.boolean().nullable(),
    nombresNoConcuerdan: zod_1.z.boolean().nullable(),
});
exports.AceptadoVistaSchema = zod_1.z.object({
    id: zod_1.z.number().int(),
    nombre: zod_1.z.string().nullable(),
    slug: zod_1.z.string().nullable(),
});
exports.DecisionVistaSchema = zod_1.z.object({
    numeroAutor: zod_1.z.number().int(),
    tipoDecision: exports.TipoDecisionAutorSchema,
    nombreAutor: zod_1.z.string(),
    estado: exports.EstadoDecisionPublicacionSchema,
    afiliacionIncierta: zod_1.z.boolean(),
    origen: exports.OrigenDecisionAutorSchema.nullable(),
    /** true for the three fill-in origins (see `esOrigenInferido`). */
    origenInferido: zod_1.z.boolean(),
    metodoCoincidencia: exports.MetodoCoincidenciaAutorSchema.nullable(),
    candidatos: zod_1.z.array(exports.CandidatoVistaSchema),
    /** null = undecided · [] = confirmed external · [x] = this investigador/unidad. */
    aceptados: zod_1.z.array(exports.AceptadoVistaSchema).nullable(),
    identificadoresAutor: zod_1.z.object({ uidFuente: zod_1.z.string().nullable(), orcids: zod_1.z.array(zod_1.z.string()) }).nullable(),
    observaciones: zod_1.z.string().nullable(),
    asignadoPor: UsuarioRefSchema.nullable(),
    fechaAsignacion: zod_1.z.string().nullable(),
    /**
     * The caso this decision lands in while `por_revisar` on a PENDING entrante; null otherwise
     * (a leftover `por_revisar` of an imported entrante never applies).
     */
    caso: exports.CasoPublicacionSchema.nullable(),
    /**
     * Other sources where a pending entrante has the same title + year (WoS and Scopus register
     * the same paper separately): deciding the author in one of them is enough. Listing only.
     */
    otrasFuentesPendientes: zod_1.z.array(exports.FuenteDatosPublicacionSchema).default([]),
});
exports.ConflictoVistaSchema = zod_1.z.object({
    campo: zod_1.z.string(),
    valorActual: zod_1.z.unknown(),
    valorEntrante: zod_1.z.unknown(),
    valorAceptado: zod_1.z.unknown().nullable(),
    estado: exports.EstadoDecisionPublicacionSchema,
    observaciones: zod_1.z.string().nullable(),
    asignadoPor: UsuarioRefSchema.nullable(),
    fechaAsignacion: zod_1.z.string().nullable(),
    /**
     * Only for `issn_revista`: how many pending ISSN conflicts of the SAME journal this
     * decision resolves (the importer closes them all). null for the other fields.
     */
    alcanceRevista: zod_1.z.number().int().nullable(),
    /** Only for `issn_revista`: the stored journal it belongs to (null when not linked). */
    revista: exports.RevistaVistaSchema.nullable().default(null),
});
exports.PublicacionCandidataVistaSchema = zod_1.z.object({
    idPublicacion: zod_1.z.number().int(),
    /** null when the candidate id no longer exists. */
    titulo: zod_1.z.string().nullable(),
    /** Effective year: COALESCE(año_publicacion, YEAR(fecha_early_access)). */
    anoPublicacion: zod_1.z.number().int().nullable(),
    /** true when the year comes from the early-access date. */
    anioEarlyAccess: zod_1.z.boolean().default(false),
    doi: zod_1.z.string().nullable(),
});
exports.ResumenEntranteSchema = zod_1.z.object({
    porRevisar: zod_1.z.number().int().nonnegative(),
    porAplicar: zod_1.z.number().int().nonnegative(),
    /**
     * Heuristic: `pendiente` + already linked to a publication stored as early access.
     * That is the early-access phase sending an imported row back (it is not terminal).
     */
    reabierta: zod_1.z.boolean(),
    /**
     * A pending entrante with an error in the latest FINISHED run of a publication automation:
     * it shows up in no review view (no decisions, candidates nor conflicts), only here.
     */
    trabada: zod_1.z.object({ tipoError: zod_1.z.string().nullable(), mensaje: zod_1.z.string().nullable() }).nullable().default(null),
});
exports.FilaEntranteSchema = zod_1.z.discriminatedUnion('tipo', [
    zod_1.z.object({ tipo: zod_1.z.literal('decision'), entrante: exports.EntranteResumenSchema, decision: exports.DecisionVistaSchema }),
    zod_1.z.object({ tipo: zod_1.z.literal('conflicto'), entrante: exports.EntranteResumenSchema, conflicto: exports.ConflictoVistaSchema }),
    zod_1.z.object({
        tipo: zod_1.z.literal('publicacion_ambigua'),
        entrante: exports.EntranteResumenSchema,
        candidatas: zod_1.z.array(exports.PublicacionCandidataVistaSchema),
    }),
    zod_1.z.object({ tipo: zod_1.z.literal('entrante'), entrante: exports.EntranteResumenSchema, resumen: exports.ResumenEntranteSchema }),
]);
exports.ListarEntrantesResponseSchema = zod_1.z.object({
    tab: exports.TabPublicacionesSchema,
    caso: exports.CasoPublicacionSchema.nullable(),
    items: zod_1.z.array(exports.FilaEntranteSchema),
    total: zod_1.z.number().int().nonnegative(),
    page: zod_1.z.number().int().positive(),
    pageSize: zod_1.z.number().int().positive(),
});
exports.ContadoresPublicacionesResponseSchema = zod_1.z.object({
    porCaso: zod_1.z.record(exports.CasoPublicacionSchema, zod_1.z.number().int().nonnegative()),
    porTab: zod_1.z.object({
        multiples: zod_1.z.number().int().nonnegative(),
        mismatch: zod_1.z.number().int().nonnegative(),
        todas: zod_1.z.number().int().nonnegative(),
    }),
    /** What `aplicar_decisiones_publicaciones` would write now. */
    porAplicar: zod_1.z.number().int().nonnegative(),
    /** Run errors (latest finished run of each publication automation) per tipo_error. */
    errores: zod_1.z.record(zod_1.z.string(), zod_1.z.number().int().nonnegative()),
    /** Pending conflicts per `campo` (chips of the conflicto caso). */
    conflictosPorCampo: zod_1.z.record(zod_1.z.string(), zod_1.z.number().int().nonnegative()).default({}),
    /** Pending entrantes stuck by a run error (see ResumenEntrante.trabada). */
    trabadas: zod_1.z.number().int().nonnegative().default(0),
    /**
     * `aplicar_decisiones_publicaciones` is running: every decision write answers 409 until it
     * ends, so the web locks its decision buttons meanwhile.
     */
    aplicandoDecisiones: zod_1.z.boolean().default(false),
});
exports.ErrorCorridaSchema = zod_1.z.object({
    idItem: zod_1.z.number().int(),
    idEjecucion: zod_1.z.number().int(),
    codigo: zod_1.z.string(),
    fecha: zod_1.z.string().nullable(),
    uidFuente: zod_1.z.string().nullable(),
    mensaje: zod_1.z.string().nullable(),
    /** null when the item has no typed detalle. */
    tipoError: zod_1.z.string().nullable(),
    detalle: zod_1.z.unknown().nullable(),
    /** The entrante with the same uid, when there is one. */
    idPublicacionEntrante: zod_1.z.number().int().nullable(),
    /** `revista_con_otro_issn`: the stored journal whose title matched with another ISSN. */
    revista: exports.RevistaVistaSchema.nullable().default(null),
});
exports.ListarErroresResponseSchema = zod_1.z.object({
    porTipo: zod_1.z.array(zod_1.z.object({ tipoError: zod_1.z.string().nullable(), total: zod_1.z.number().int().nonnegative() })),
    items: zod_1.z.array(exports.ErrorCorridaSchema),
    total: zod_1.z.number().int().nonnegative(),
    page: zod_1.z.number().int().positive(),
    pageSize: zod_1.z.number().int().positive(),
});
exports.DetalleEntranteResponseSchema = zod_1.z.object({
    entrante: exports.EntranteResumenSchema,
    resumen: exports.ResumenEntranteSchema,
    /** The linked publication, when the entrante already points to one. */
    publicacion: zod_1.z
        .object({
        idPublicacion: zod_1.z.number().int(),
        titulo: zod_1.z.string(),
        /** Effective year: COALESCE(año_publicacion, YEAR(fecha_early_access)). */
        anoPublicacion: zod_1.z.number().int().nullable(),
        anioEarlyAccess: zod_1.z.boolean().default(false),
        doi: zod_1.z.string().nullable(),
        earlyAccess: zod_1.z.boolean().nullable(),
    })
        .nullable(),
    decisiones: zod_1.z.array(exports.DecisionVistaSchema),
    conflictos: zod_1.z.array(exports.ConflictoVistaSchema),
    candidatas: zod_1.z.array(exports.PublicacionCandidataVistaSchema),
    /** Other entrantes (other sources) that point to the same publication. */
    hermanas: zod_1.z.array(exports.EntranteResumenSchema),
    /** Pending conflicts of those sibling entrantes: both versions side by side before deciding. */
    conflictosHermanas: zod_1.z
        .array(zod_1.z.object({ entrante: exports.EntranteResumenSchema, conflicto: exports.ConflictoVistaSchema }))
        .default([]),
    errores: zod_1.z.array(exports.ErrorCorridaSchema),
});
// ─── Write contracts (all bulk-capable) ───
const id = zod_1.z.number().int().positive();
const lote = (item) => zod_1.z.array(item).min(1).max(200);
exports.DecidirInvestigadorSchema = zod_1.z.object({
    items: lote(zod_1.z.object({
        idPublicacionEntrante: id,
        numeroAutor: zod_1.z.number().int().nonnegative(),
        /** null = the author is EXTERNAL (written as `[]`). */
        idInvestigador: id.nullable(),
    })),
});
exports.DecidirUnidadSchema = zod_1.z.object({
    items: lote(zod_1.z.object({ idPublicacionEntrante: id, numeroAutor: zod_1.z.number().int().nonnegative(), idUnidad: id })),
});
exports.AceptarMejorCandidatoSchema = zod_1.z.object({
    items: lote(zod_1.z.object({ idPublicacionEntrante: id, numeroAutor: zod_1.z.number().int().nonnegative() })),
});
exports.DevolverDecisionSchema = zod_1.z.object({
    items: lote(zod_1.z.object({
        idPublicacionEntrante: id,
        numeroAutor: zod_1.z.number().int().nonnegative(),
        tipoDecision: exports.TipoDecisionAutorSchema,
    })),
});
exports.DecidirConflictoSchema = zod_1.z.object({
    items: lote(zod_1.z
        .object({
        idPublicacionEntrante: id,
        campo: zod_1.z.string().min(1).max(64),
        usar: zod_1.z.enum(['entrante', 'actual']).optional(),
        valorAceptado: zod_1.z.unknown().optional(),
    })
        .superRefine((v, ctx) => {
        const tieneValor = v.valorAceptado !== undefined;
        if ((v.usar !== undefined) === tieneValor) {
            ctx.addIssue({ code: 'custom', message: 'Indicá «usar» o «valorAceptado» (uno de los dos).' });
        }
    })),
});
exports.DevolverConflictoSchema = zod_1.z.object({
    items: lote(zod_1.z.object({ idPublicacionEntrante: id, campo: zod_1.z.string().min(1).max(64) })),
});
exports.ElegirAccionSchema = zod_1.z
    .object({
    /** null = undo the choice (back to "publicación ambigua"). */
    accion: exports.AccionPublicacionEntranteSchema.nullable(),
    idPublicacion: id.optional(),
})
    .superRefine((v, ctx) => {
    if (v.accion === 'actualizar_existente' && v.idPublicacion === undefined) {
        ctx.addIssue({ code: 'custom', path: ['idPublicacion'], message: 'Elegí la publicación existente.' });
    }
    if (v.accion !== 'actualizar_existente' && v.idPublicacion !== undefined) {
        ctx.addIssue({ code: 'custom', path: ['idPublicacion'], message: 'Sólo «actualizar_existente» lleva publicación.' });
    }
});
exports.DescartarEntrantesSchema = zod_1.z.object({
    items: lote(zod_1.z.object({ idPublicacionEntrante: id })),
    observaciones: zod_1.z.string().trim().min(1, 'Indicá el motivo del descarte.').max(2000),
});
exports.CampoIdentificadorSchema = zod_1.z.enum(['orcid', 'uid_fuente']);
exports.CopiarIdentificadoresSchema = zod_1.z.object({
    idPublicacionEntrante: id,
    numeroAutor: zod_1.z.number().int().nonnegative(),
    idInvestigador: id,
    campos: zod_1.z.array(exports.CampoIdentificadorSchema).min(1).max(2),
    /** Which ORCID, when the source declared more than one. */
    orcid: zod_1.z.string().trim().min(1).max(19).optional(),
    /** Replace a different value already stored on the investigador. */
    sobrescribir: zod_1.z.boolean().optional().default(false),
});
exports.TipoFalloItemSchema = zod_1.z.enum(['no_disponible', 'no_encontrado', 'invalido', 'conflicto']);
exports.ResultadoItemSchema = zod_1.z.object({
    /** Position of the item in the request. */
    indice: zod_1.z.number().int().nonnegative(),
    ok: zod_1.z.boolean(),
    motivo: zod_1.z.string().nullable(),
    tipoFallo: exports.TipoFalloItemSchema.nullable(),
    /** Only for `issn_revista` conflicts (see ConflictoVista.alcanceRevista). */
    alcanceRevista: zod_1.z.number().int().nullable(),
});
exports.ResultadoLoteResponseSchema = zod_1.z.object({
    resultados: zod_1.z.array(exports.ResultadoItemSchema),
    aplicados: zod_1.z.number().int().nonnegative(),
    omitidos: zod_1.z.number().int().nonnegative(),
});
exports.ColumnaIdentificadorSchema = zod_1.z.enum(['orcid', 'wos_researcher_id', 'scopus_author_id']);
exports.CopiarIdentificadoresResponseSchema = zod_1.z.object({
    actualizados: zod_1.z.array(exports.ColumnaIdentificadorSchema),
    sinCambios: zod_1.z.array(exports.ColumnaIdentificadorSchema),
});
